import axiosClient from "../../api/axiosClient";

export const allAbsencesOfStudent = async (studentId) => {
  const response = await axiosClient.get("/Manager/Absence/GetAbsencesOfStudent/" + studentId);
  return response.data;
};